import { BookingDto, IProduceJoinPassengerPreviewDto } from "../../dto";
import { ITypeormWhereCriteria } from "../../models";
import { OperatorDescriptor } from "../../models/filters.models";

export type IProductionCriteria = ITypeormWhereCriteria<BookingDto> &
  IProduceJoinPassengerPreviewDto;

export const asOperatorDescriptor = (
  value: unknown,
): OperatorDescriptor | undefined => value as OperatorDescriptor | undefined;

export const extractPassengerTypeIdsFromPassengerCriteria = (
  passenger: IProductionCriteria["passenger"],
): number[] | undefined => {
  const passengerTypeId = asOperatorDescriptor(passenger?.passengerTypeId);
  const passengerTypeIdIn = passengerTypeId?.$in as number[] | undefined;
  if (passengerTypeIdIn?.length) {
    return passengerTypeIdIn;
  }

  const passengerTypeIdEq = passengerTypeId?.$eq as number | undefined;
  if (passengerTypeIdEq !== undefined && passengerTypeIdEq !== null) {
    return [passengerTypeIdEq];
  }

  return undefined;
};

export const extractSectorsFromProductionCriteria = (
  criteria: IProductionCriteria | undefined,
): string[] | undefined => {
  const sectors = (
    asOperatorDescriptor(criteria?.passengerSector)?.$in as string[] | undefined
  )?.filter(Boolean);
  return sectors?.length ? sectors : undefined;
};

/** Matches backend `getDirectionForProduction`: PickUp+DropOff → DirectionEnum.Both ("AB"). */
export const joinDirectionInValues = (directionIn: string[]): string =>
  directionIn.join("");
